import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('REDIRECT', {
  REDIRECT: null
});
